import React from "react";
import { Link, useLocation } from "react-router-dom";
import BarChartIcon from "@mui/icons-material/BarChart";
import ChatIcon from "@mui/icons-material/Chat";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import Groups2Icon from "@mui/icons-material/Groups2";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import TuneIcon from "@mui/icons-material/Tune";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Logo from "../../../components/Logo/logo";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  Email as InvitationsIcon,
  CalendarToday as SessionsIcon,
  Apps as AppsIcon,
  AccountCircle as AccountIcon,
  HelpOutline as SupportIcon,
} from "@mui/icons-material";
import { getNavigationMenu } from "../../../helpers/roleUtils";

const Sidebar = ({
  isCollapsed,
  setIsCollapsed,
  isSidebarOpenMobile,
  setIsSidebarOpenMobile,
}) => {
  const location = useLocation();
  const isActive = (path) => location.pathname.includes(path);
  const { message, messageSeen } = useSelector((state) => state.broadcastMessage);
  const { user, userRoleInfo } = useSelector((state) => state.auth);
  const broadcastText = message?.[0]?.attributes?.broadcast_msg || "";
 
  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  // Icon mapping for dynamic menu items
  const iconMap = {
    BarChartIcon,
    ChatIcon,
    CalendarMonthIcon,
    Groups2Icon,
    PeopleAltIcon,
    AttachMoneyIcon,
    SettingsIcon,
    AccountIcon,
    HelpOutlineIcon,
    InvitationsIcon,
    SessionsIcon,
    AppsIcon,
  };

  // Get navigation menu based on user role
  const menuItems = getNavigationMenu(user).map(item => ({
    ...item,
    icon: iconMap[item.icon] || HelpOutlineIcon,
    exact: item.exact || false
  }));

  // Responsive sidebar classes
  const sidebarClass = [
    "Sidebar",
    isCollapsed ? "collapsed" : "",
    isSidebarOpenMobile ? "open-mobile" : "",
  ].join(" ");

  // Only show close button on mobile
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 900;

  return (
    <div
      className={sidebarClass}
      style={isSidebarOpenMobile ? { zIndex: 1100 } : {}}
    >
      {/* Mobile close button */}
      {isSidebarOpenMobile && (
        <button
          className="sidebar-mobile-close"
          onClick={() => setIsSidebarOpenMobile(false)}
          style={{
            position: "absolute",
            top: 12,
            right: 12,
            background: "none",
            border: "none",
            fontSize: 28,
            color: "#22314a",
            zIndex: 1201,
            cursor: "pointer",
          }}
        >
          ×
        </button>
      )}
      <div>
        <nav className={`sidebar-nav`}>
          <ul className="nav-list">
            {menuItems.map((item) => {
              const IconComponent = item.icon;
              return (
                <li key={item.path} className="nav-item">
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `nav-link ${isActive ? "active" : ""}`
                    }
                    end={item.exact}
                  >
                    <IconComponent className="nav-icon" />
                    {!isCollapsed && (
                      <span className="nav-label">{item.label}</span>
                    )}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
      <div className="sidebar-bottom">
        Powered by
        <strong>
          <Logo />
        </strong>
      </div>
    </div>
  );
};

export default Sidebar;
